// @flow

import * as React from "react"
import Modal from "react-modal"
import {connect} from "react-redux"
import {withTranslation} from "react-i18next"
import ClassNames from "classnames"
import PlanningItemAddModal from "../../components/modals/planning-item-add"
import ConfirmModal from "../../components/modals/confirm"
import Icon from "../../components/icon"
import {
  setPlanning,
  setPlanningBaby,
  markAllPlanningItemsAsDone,
} from "../../actions/planning"

import PlanningList from "../../components/planning-list"
import Config from "../../config"
import type {State as ReduxState, PlanningState, Dispatch} from "../../types"

type Props = {
  dispatch: Dispatch,
  planning: PlanningState,
  t: any,
}

type ModalType = "add_planning_item" | "confirm_mark_all_as_done"

type State = {
  +isModalOpen: boolean,
  +modalType: ?ModalType,
  +babyId: ?number,
}

class PlanningDashboardView extends React.Component<Props, State> {
  handleAdd: () => void
  handleCloseModal: () => void
  handleAfterOpen: () => void
  handleMarkAllAsDone: (SyntheticMouseEvent<HTMLElement>) => void
  handleConfirmMarkAllAsDoneModal: () => void

  state = {
    isModalOpen: false,
    modalType: null,
    babyId: null,
  }

  constructor(props: Props) {
    super(props)

    Modal.setAppElement("#app")

    this.state = {
      isModalOpen: false,
      modalType: null,
      babyId: Config.data.babyId,
    }

    this.props.dispatch(setPlanningBaby(Config.data.babyToken))
    this.handleConfirmMarkAllAsDoneModal =
      this.handleConfirmMarkAllAsDoneModal.bind(this)
    this.handleMarkAllAsDone = this.handleMarkAllAsDone.bind(this)
    this.handleAdd = this.handleAdd.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleAfterOpen = this.handleAfterOpen.bind(this)
  }

  componentDidMount() {
    // for dashboard views, the base entities are already output in the html
    this.props.dispatch(setPlanning(Config.data.planningItems))
  }

  handleAdd() {
    this.setState({
      modalType: "add_planning_item",
      isModalOpen: true,
    })
  }

  handleCloseModal() {
    this.setState({isModalOpen: false})
  }

  handleAfterOpen() {}

  handleMarkAllAsDone(e: SyntheticMouseEvent<HTMLElement>) {
    e.preventDefault()
    this.setState({isModalOpen: true, modalType: "confirm_mark_all_as_done"})
  }

  handleConfirmMarkAllAsDoneModal() {
    const {dispatch} = this.props
    dispatch(markAllPlanningItemsAsDone(Config.data.babyToken))
    this.setState({isModalOpen: false})
  }

  renderModal() {
    const {isModalOpen, modalType, babyId} = this.state
    if (!isModalOpen) {
      return null
    }
    switch (modalType) {
      case "add_planning_item":
        return (
          <PlanningItemAddModal
            handleCloseModal={this.handleCloseModal}
            handleAfterOpen={this.handleAfterOpen}
            babyId={babyId}
          />
        )

      case "confirm_mark_all_as_done":
        return (
          <ConfirmModal
            onConfirm={this.handleConfirmMarkAllAsDoneModal}
            onCancel={this.handleCloseModal}
          />
        )
    }
    return null
  }

  renderMarkAllAsDone() {
    const {t, planning} = this.props
    if (planning.entities.length > 0) {
      return (
        <div className="justify-content-end flex mr-4">
          <a
            href="#"
            onClick={this.handleMarkAllAsDone}
            className="d-block"
            title={t("dashboard.planning.markAllAsDone")}
          >
            {t("dashboard.planning.markAllAsDone")}
          </a>
        </div>
      )
    }
    return null
  }

  render() {
    const {planning} = this.props
    const {babyId} = this.state
    const classNames = ClassNames(
      "dashboard-view planning-dashboard container mt-4",
      {
        "madam-dashboard": !babyId,
      }
    )
    const addButton = (
      <button
        className="action-dot-button action-dot-button"
        onClick={this.handleAdd}
      >
        <Icon name="icon-plus" />
      </button>
    )
    // <h1 className="m-0">{t('dashboard.planning.title')}</h1>
    const header = !babyId ? (
      <div className="d-flex justify-content-between align-items-center mb-4 mr-2">
        {addButton}
      </div>
    ) : (
      <React.Fragment>
        <div className="row">
          <div className="col-lg-10 col-xl-8 mb-2">
            {this.renderMarkAllAsDone()}
          </div>
        </div>
        {addButton}
      </React.Fragment>
    )

    return (
      <React.Fragment>
        <div className={classNames}>
          {header}
          <div className="row">
            <div className="col-lg-10 col-xl-8">
              <PlanningList
                planningItems={planning.entities}
                showMadam={false}
                readyOnly={false}
              />
            </div>
          </div>
        </div>
        {this.renderModal()}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  planning: state.planning,
})

export default withTranslation()(
  connect(mapStateToProps)(PlanningDashboardView)
)
